/**
 * Onboarding Page Event Tracking
 *
 * Tracks form submission with field values (weight, height, goal, BMC).
 */
import { trackEngagement } from './index.js';

function getUserContext() {
	return {
		user_id: wpcore?.user_id ?? 0,
		user_role: wpcore?.user_role ?? 'guest',
	};
}

export function trackOnboardingCompleted(formValues = {}) {
	trackEngagement('onboarding_completed', {
		...getUserContext(),
		weight: formValues.weight || '',
		height: formValues.height || '',
		weight_goal: formValues.weight_goal || '',
		bone_mass: formValues.bone_mass || '',
	});
}
